<template>
  <v-html-panel :url.sync="url" style="background-color: #ffffff;"></v-html-panel>
</template>
<script>
import { setStorage, getStorage } from "@/libs/utils";
export default {
  data() {
    return {
      url: ""
    };
  },
  mounted() {
    if (this.$route.params.index) {
      setStorage("terms", this.$route.params.index, true);
      this.url = unescape(this.$route.params.index);
    } else {
      let url = getStorage("terms");
      this.url = unescape(url);
    }
    // this.url = 'https://mcloudapi.moveclub.cn/match/matchintro?matchid=92'
  },
  methods: {}
};
</script>